import React, { useState, useEffect, useContext } from "react";
import './LeaderTour.css';
import { LeaderAPIs } from "../../../../API/LeaderAPIs/LeaderAPIs";
import ViewLeaderTour from "./ViewLeaderTour/ViewLeaderTour";
import { useNavigate, useParams } from "react-router-dom";
import NotificationContext from "../../../../STCLibrary/NotificationSystem/NotificationContext";
import ApiResponseHandler from "../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler";
import STC from "../../../../STCLibrary/STCFactory/STCFactory";

function LeaderTours() {
  
  const routeParams = useParams();
  const navigate = useNavigate();
  const notificationCtx = useContext(NotificationContext);
  const [tours, setTours] = useState([]);


  const getLeaderTours = () => {
    
    LeaderAPIs.GetLeaderTours(routeParams.userID)
    .then((response) =>{
      if(response.status === 200) {
        setTours(response.data.reverse())
      }
    })
    .catch((err) => {
      console.log(err)
      ApiResponseHandler(err.response, notificationCtx, navigate);
    })

  };

  useEffect(() => {
    getLeaderTours();
  }, []);


  return (
    <div>
      {tours.length > 0 ? 
      tours.map((tour, index) => {
        return(
          <div key={index} className='leader-tour-container'>
            <ViewLeaderTour tourID={tour}/>
          </div>
        )
      })
    :
      <div style={{display: "flex", justifyContent: 'center', alignItems: 'center'}}>
        <STC.Alert style={{maxWidth: '600px', textAlign: 'center', margin: '2rem'}} variant='warning' >No tours have been added to your account yet. Please contact your sales representative if you have any queries.</STC.Alert>
      </div>
     }
    </div>
  );
}

export default LeaderTours